(function () {

angular.module('kv').component('validatorErrors',
	{
		templateUrl: '/assets/custom/js/directives/validator-errors/validator-errors.component.html',
	});

}());